import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrgCreationComponent} from './org-creation.component';
import {TranslateModule} from '@xref/ngx';
import {HeaderModule} from "../header/header.module";
import {FooterModule} from "../footer/footer.module";
import {BannerModule, ButtonModule, DropdownModule, InputsModule} from "@xref/xref-lib";
import {FormsModule} from "@angular/forms";
import {OmniLoaderModule} from "../omni-loader/omni-loader.module";

@NgModule({
    declarations: [OrgCreationComponent],
    imports: [
        CommonModule,
        TranslateModule,
        HeaderModule, FooterModule,
        InputsModule,
        FormsModule,
        ButtonModule,
        DropdownModule,
        OmniLoaderModule,
        BannerModule
    ],
    exports: [OrgCreationComponent]
})
export class OrgCreationModule {
}
